import { cadStr } from "@/lib/pricing";

// Terms §5 commercial pricing, read from GET /api/pricing/current (same numbers billing uses). Wording unchanged otherwise.
const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

function planLine(p) {
  const price = p.monthly_cad === "0.00" ? "CA$0/month (no subscription fee)"
    : `${cadStr(p.monthly_cad)}/month or ${cadStr(p.annual_cad)}/year`;
  return `${price} · includes ${plural(p.storefronts_included, "storefront")} and up to ${plural(p.provinces_included_per_storefront, "province")} per storefront · Performance Fee ${p.fee_pct}% of the eligible sale or ${cadStr(p.fee_minimum_cad)} per verified sale (whichever is higher).`;
}

export function FinalPlanTerms({ pricing, asOf }) {
  const addon = (id) => pricing.addons.find((a) => a.id === id);
  const prov = addon("additional_province");
  const sf = addon("additional_storefront");
  return (
    <>
      <p data-testid="terms-plans-intro">
        Merchants choose a {pricing.plans.map((p) => p.name).join(", ").replace(/, ([^,]*)$/, " or $1")} plan billed
        monthly or annually in Canadian dollars, plus a Performance Fee applied to each verified sale attributed to
        Cyannect. As of {asOf}:
      </p>
      <ul className="list-disc list-outside pl-5 space-y-1" data-testid="terms-plans-list">
        {pricing.plans.map((p) => (
          <li key={p.id} data-testid={`terms-plan-${p.id}`}><strong>{p.name}</strong> — {planLine(p)}</li>
        ))}
        {prov && <li><strong>Add-on province</strong> — {cadStr(prov.monthly_cad)}/month per additional province, per storefront.</li>}
        {sf && <li><strong>Add-on storefront</strong> — {cadStr(sf.monthly_cad)}/month per additional storefront.</li>}
        <li><strong>Annual add-ons</strong> — priced as monthly × 12 × 0.85 (a flat {pricing.annual_addon_discount_pct}% discount off the yearly value), billed annually and aligned to your base-plan renewal.</li>
      </ul>
    </>
  );
}
